module.exports = __webpack_public_path__ + "img/req_sale_bg.c635297e.png";